import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Factura } from 'src/app/Models/factura/factura';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { Ingreso } from 'src/app/Models/ingreso/ingreso';
import { Personal } from 'src/app/Models/personal/personal';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { AddPersonalComponent } from './add-personal/add-personal.component';
import { AlertComponent } from '../objects/alert/alert/alert.component';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { TipoDocumento } from 'src/app/Models/tipodocumento/tipo-documento';
import { ClienteEditComponent } from '../cliente/cliente-edit/cliente-edit.component';
import { LoadingComponent } from '../objects/loading/loading.component';
import { NothingComponent } from '../objects/nothing/nothing.component';

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.css']
})
export class PersonalComponent implements OnInit {
  @ViewChild(AddPersonalComponent, null) newpersonal: AddPersonalComponent;
  @ViewChild(LoadingComponent, null) public loading: LoadingComponent;
  @ViewChild(NothingComponent, null) public nothing: NothingComponent;
  @ViewChild(AlertComponent, null) public alert: AlertComponent;
  @ViewChild(ClienteEditComponent, null) public fmclienteedit: ClienteEditComponent;
  public cliente: Cliente = new Cliente();
  public total: number = 0;
  public pgcliente: any;
  public busqueda: string = '';
  public usuario: any;
  public ingreso: Ingreso = new Ingreso();
  public alertType: AlertType = new AlertType();
  public options: ALertOption = new ALertOption();
  public index: number = 0;
  public numitem: number = 0;
  public tiposgastos: any[] = [];
  tipodocumentos: any[] = [];
  public pagarticulo: any;
  public formapagos: any[] = []
  public filtro: Filtro = new Filtro()
  public factura: Factura = new Factura()
  public listapersonal: Personal[] = [];
  public personal: Personal = new Personal()
  public newusuario: Usuario = new Usuario();
  public adduser: boolean = false;
  public search = { top: 10, clase: 0, subclase: 0, subgrupo: 0, nombre: '', codigo: '', opcion: 'nombre', scale: 'DESC', fechaprogd: this.data.DateNowCurrent(), fechaprogh: this.data.DateNowCurrent(), text: "" }
  constructor(private title: Title, private data: DataService, private notify: NotifyService, private auth: AuthService, private route: Router) { }

  ngOnInit() {
    this.title.setTitle('Personal | Sistema de ventas');
    this.usuario = this.auth.getCurrentUser();
    this.tipodocumentos = [{ codigo: '1', descripcion: "DNI" }, { codigo: '4', descripcion: "CARNET DE EXTRANJERIA" }, { codigo: '-', descripcion: "OTROS" }]
    console.log(this.usuario);
    console.log(this.usuario.idpersonal.idpersonal);
    this.GetPersonal()
  }

  GetPersonal() {
    this.loading.show('cargando datos');
    this.listapersonal = [];

    this.data.GetSimple(this.data.api.personal).subscribe(r => {
      this.loading.hide();
      if (this.data.Exists(r) && Array.isArray(r)) {
        console.log(r);

        // Filtrar para excluir el personal cuyo id numeric === 1
        this.listapersonal = r.filter(person => {
          const id = Number(person.idpersonal || person.id || person.id_personal);
          return id !== 1;
        });

        this.total = this.listapersonal.length;
      } else {
        this.listapersonal = [];
        this.total = 0;
      }
    }, e => { console.log(e.error.text) });
  }

  busquedapersonal() {
    this.loading.show('cargando datos');
    this.listapersonal = [];

    this.data.GetFromValue(this.data.api.personal, 'like', this.busqueda).subscribe(r => {
      this.loading.hide();
      if (this.data.Exists(r)) {
        console.log(r);

        this.listapersonal = r;
        this.total = this.listapersonal.length;
      } else { this.listapersonal = []; this.total = 0; }
    }, e => { console.log(e.error.text) });
  }

  SearchPersonal() {
    if (this.busqueda != '') {
      this.busquedapersonal();
    } else {
      this.GetPersonal();
    }
  }

  AddPersonal() {
    this.newpersonal.isedit = false
    this.newpersonal.personal = new Personal()
    this.newpersonal.newusuario = new Usuario()
    this.newpersonal.show(() => {
      console.log("cerrado con exito");
      this.SearchPersonal()
    })
  }

  EditPersonal(i) {
    this.newpersonal.isedit = true
    this.newpersonal.personal = i
    i.idusuario ? this.newpersonal.newusuario.username = i.idusuario.username : this.newpersonal.newusuario = new Usuario()
    this.newpersonal.show(() => {
      console.log("cerrado con exito");
      this.SearchPersonal()
    })
  }
}
